var _filter, _circle, _circle2, _circle3, _g, _text, _text2, _text3, _text4, _text5, _text6, _text7, _text8, _g2, _circle4, _circle5, _circle6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 300",
    width: 300,
    height: 300,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "ringGradient",
    cx: "50%",
    cy: "50%",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#f0f0f0",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#d0d0d0",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "northGradient",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#ff4444",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#cc0000",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "southGradient",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#e0e0e0",
      stopOpacity: 1
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "shadow",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    result: "offsetblur"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", null, /*#__PURE__*/React.createElement("feFuncA", {
    type: "linear",
    slope: 0.3
  })), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", null), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 150,
    r: 145,
    fill: "#ffffff",
    stroke: "#333",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 150,
    r: 140,
    fill: "none",
    stroke: "url(#ringGradient)",
    strokeWidth: 8
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 150,
    r: 135,
    fill: "none",
    stroke: "#666",
    strokeWidth: 1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#333",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("line", {
    x1: 150,
    y1: 20,
    x2: 150,
    y2: 35,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 217.5,
    y1: 42.5,
    x2: 208.5,
    y2: 54.5,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 257.5,
    y1: 82.5,
    x2: 245.5,
    y2: 91.5,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280,
    y1: 150,
    x2: 265,
    y2: 150,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 257.5,
    y1: 217.5,
    x2: 245.5,
    y2: 208.5,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 217.5,
    y1: 257.5,
    x2: 208.5,
    y2: 245.5,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 150,
    y1: 280,
    x2: 150,
    y2: 265,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82.5,
    y1: 257.5,
    x2: 91.5,
    y2: 245.5,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 42.5,
    y1: 217.5,
    x2: 54.5,
    y2: 208.5,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 150,
    x2: 35,
    y2: 150,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 42.5,
    y1: 82.5,
    x2: 54.5,
    y2: 91.5,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82.5,
    y1: 42.5,
    x2: 91.5,
    y2: 54.5,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("line", {
    x1: 150,
    y1: 20,
    x2: 150,
    y2: 30,
    transform: "rotate(10 150 150)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 150,
    y1: 20,
    x2: 150,
    y2: 30,
    transform: "rotate(20 150 150)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 150,
    y1: 20,
    x2: 150,
    y2: 30,
    transform: "rotate(40 150 150)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 150,
    y1: 20,
    x2: 150,
    y2: 30,
    transform: "rotate(50 150 150)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 150,
    y1: 20,
    x2: 150,
    y2: 30,
    transform: "rotate(70 150 150)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 150,
    y1: 20,
    x2: 150,
    y2: 30,
    transform: "rotate(80 150 150)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 150,
    y1: 20,
    x2: 150,
    y2: 30,
    transform: "rotate(100 150 150)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 150,
    y1: 20,
    x2: 150,
    y2: 30,
    transform: "rotate(110 150 150)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 150,
    y1: 20,
    x2: 150,
    y2: 30,
    transform: "rotate(130 150 150)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 150,
    y1: 20,
    x2: 150,
    y2: 30,
    transform: "rotate(140 150 150)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 150,
    y1: 20,
    x2: 150,
    y2: 30,
    transform: "rotate(160 150 150)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 150,
    y1: 20,
    x2: 150,
    y2: 30,
    transform: "rotate(170 150 150)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 150,
    y1: 20,
    x2: 150,
    y2: 30,
    transform: "rotate(190 150 150)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 150,
    y1: 20,
    x2: 150,
    y2: 30,
    transform: "rotate(200 150 150)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 150,
    y1: 20,
    x2: 150,
    y2: 30,
    transform: "rotate(220 150 150)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 150,
    y1: 20,
    x2: 150,
    y2: 30,
    transform: "rotate(230 150 150)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 150,
    y1: 20,
    x2: 150,
    y2: 30,
    transform: "rotate(250 150 150)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 150,
    y1: 20,
    x2: 150,
    y2: 30,
    transform: "rotate(260 150 150)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 150,
    y1: 20,
    x2: 150,
    y2: 30,
    transform: "rotate(280 150 150)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 150,
    y1: 20,
    x2: 150,
    y2: 30,
    transform: "rotate(290 150 150)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 150,
    y1: 20,
    x2: 150,
    y2: 30,
    transform: "rotate(310 150 150)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 150,
    y1: 20,
    x2: 150,
    y2: 30,
    transform: "rotate(320 150 150)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 150,
    y1: 20,
    x2: 150,
    y2: 30,
    transform: "rotate(340 150 150)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 150,
    y1: 20,
    x2: 150,
    y2: 30,
    transform: "rotate(350 150 150)"
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 55,
    fontFamily: "Arial, sans-serif",
    fontSize: 32,
    fontWeight: "bold",
    fill: "#cc0000",
    textAnchor: "middle"
  }, "N")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 245,
    y: 157,
    fontFamily: "Arial, sans-serif",
    fontSize: 32,
    fontWeight: "bold",
    fill: "#333",
    textAnchor: "middle"
  }, "E")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 255,
    fontFamily: "Arial, sans-serif",
    fontSize: 32,
    fontWeight: "bold",
    fill: "#333",
    textAnchor: "middle"
  }, "S")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 55,
    y: 157,
    fontFamily: "Arial, sans-serif",
    fontSize: 32,
    fontWeight: "bold",
    fill: "#333",
    textAnchor: "middle"
  }, "W")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 213,
    y: 90,
    fontFamily: "Arial, sans-serif",
    fontSize: 24,
    fontWeight: "bold",
    fill: "#666",
    textAnchor: "middle"
  }, "NE")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 92,
    y: 90,
    fontFamily: "Arial, sans-serif",
    fontSize: 24,
    fontWeight: "bold",
    fill: "#666",
    textAnchor: "middle"
  }, "NW")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 213,
    y: 213,
    fontFamily: "Arial, sans-serif",
    fontSize: 24,
    fontWeight: "bold",
    fill: "#666",
    textAnchor: "middle"
  }, "SE")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 92,
    y: 213,
    fontFamily: "Arial, sans-serif",
    fontSize: 24,
    fontWeight: "bold",
    fill: "#666",
    textAnchor: "middle"
  }, "SW")), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 150,150 L 140,145 L 150,40 L 160,145 Z",
    fill: "url(#northGradient)",
    stroke: "#990000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 150,150 L 140,155 L 150,260 L 160,155 Z",
    fill: "url(#southGradient)",
    stroke: "#999",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 150,150 L 155,140 L 260,150 L 155,160 Z",
    fill: "#e8e8e8",
    stroke: "#999",
    strokeWidth: 1,
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 150,150 L 145,140 L 40,150 L 145,160 Z",
    fill: "#e8e8e8",
    stroke: "#999",
    strokeWidth: 1,
    opacity: 0.7
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 150,
    r: 12,
    fill: "#333",
    stroke: "#666",
    strokeWidth: 1
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 150,
    r: 8,
    fill: "#f0f0f0",
    stroke: "#333",
    strokeWidth: 1
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 150,
    r: 3,
    fill: "#333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompass);
export default __webpack_public_path__ + "static/media/compass.2ef49f65df601dc25a6146557cd85a8f.svg";
export { ForwardRef as ReactComponent };